import { forwardRef } from 'react';
import './styles.scss';

const SeoTextBar = forwardRef<HTMLElement>((_, ref) => (
  <section ref={ref} className='seo-text-section'>
    <div className='seo-text-section__container'>
      <h2 className='seo-text-section__title'>Устричные бары у дома</h2>

      <div className='seo-text-section__content'>
        <p className='seo-text-section__text'>
          Устричные бары Деликатеска — это современные заведения для тех, кто
          ценит свежие морепродукты и качественный сервис. Формат позволяет
          попробовать морские деликатесы рядом с домом без необходимости ехать в
          ресторан в центре города. Наши бары расположены в удобных локациях и
          подходят как для быстрого перекуса, так и для встреч с друзьями или
          семейного отдыха.
        </p>

        <p className='seo-text-section__text'>
          Мы считаем, что хорошие морепродукты не должны быть редким
          удовольствием для особого случая. Поэтому развиваем формат устричных
          баров рядом с домом, где можно в любой день попробовать свежие
          устрицы, морского ежа и другие деликатесы в комфортной атмосфере и по
          доступной цене.
        </p>

        <h3 className='seo-text-section__subtitle'>
          Устричный бар с широким выбором морепродуктов
        </h3>
        <p className='seo-text-section__text'>
          В меню представлены различные виды устриц, морской еж, креветки,
          гребешки, рыба и другие морепродукты. Каждая устрица проходит контроль
          качества и подается с соблюдением рекомендаций по хранению и
          сервировке. Гости могут выбирать как классические позиции, так и
          сезонные предложения.
        </p>

        <p className='seo-text-section__text'>
          Помимо морских деликатесов, меню включает закуски и блюда, которые
          хорошо сочетаются с морской кухней. Благодаря разнообразию
          ассортимента каждый посетитель может подобрать подходящий вариант
          независимо от гастрономических предпочтений и опыта знакомства с
          моллюсками.
        </p>

        <h3 className='seo-text-section__subtitle'>
          Устричные бары в Москве: качество и свежесть
        </h3>
        <p className='seo-text-section__text'>
          Главный принцип работы сети — использование свежих продуктов и высокий
          стандарт обслуживания. Мы сотрудничаем с проверенными поставщиками и
          внимательно контролируем качество каждой поставки. Хороший сервис,
          честная цена и удобное расположение делают наши заведения популярным
          местом для регулярных встреч и отдыха.
        </p>

        <p className='seo-text-section__text'>
          Отзывы гостей помогают нам совершенствовать работу и расширять
          ассортимент. Если вы ищете устричный бар в Москве рядом с домом, где
          представлены свежие морепродукты, разнообразное меню и качественный
          сервис, устричные бары Деликатеска станут отличным выбором для
          знакомства с современной морской кухней.
        </p>
      </div>
    </div>
  </section>
));

export default SeoTextBar;
